import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StudentDetailsViewState {
    [key: string]: string;
}

const initialState: StudentDetailsViewState = {
    studentDetailsView: 'stack',
};

const studentDetailsViewSlice = createSlice({
    name: 'studentDetailsView',
    initialState,
    reducers: {
        setStudentDetailsView: (state, action: PayloadAction<{ key: string; value: string }>) => {
            if (state.hasOwnProperty(action.payload.key)) {
                state[action.payload.key] = action.payload.value;
            }
        },
        resetStudentDetailsView: () => initialState,
    },
});
export const { setStudentDetailsView, resetStudentDetailsView } = studentDetailsViewSlice.actions;
export default studentDetailsViewSlice.reducer;